module.exports = {
  GLOBAL: 'global',
  PUSH: 'push',
  STORE: 'store',
};
